import { type BufferGeometry, Light, Mesh, MeshStandardMaterial, PerspectiveCamera } from "three";

export const isMesh = (value: unknown): value is Mesh => value instanceof Mesh;

export const isMeshWithStandardMaterial = (value: unknown): value is Mesh<BufferGeometry, MeshStandardMaterial> => {
    return isMesh(value) && value.material instanceof MeshStandardMaterial;
};

export const isLight = (value: unknown): value is Light => value instanceof Light && value.isLight;

export const isPerspectiveCamera = (value: unknown): value is PerspectiveCamera => value instanceof PerspectiveCamera;
